export const USER_MODULE      = "user";
export const TASKS_MODULE     = "tasks";
export const NOTES_MODULE     = "notes";
export const ITEMS_MODULE     = "items";
export const TEMPLATES_MODULE = "templates";

export const G_TEMPLATES_MODULE = TEMPLATES_MODULE;
export const G_USER_MODULE    = USER_MODULE;
export const G_TASKS_MODULE   = `${G_USER_MODULE}/${TASKS_MODULE}`;

export const g_group_module   = group_id => `${USER_MODULE}/${group_id}`;
export const g_notes_module   = group_id => `${USER_MODULE}/${group_id}/${NOTES_MODULE}`;
export const g_context_module = (group_id, context_id) => `${USER_MODULE}/${group_id}/${context_id}`;
export const g_items_module   = (group_id, context_id) => `${USER_MODULE}/${group_id}/${context_id}/${ITEMS_MODULE}`;

export const CONTEXT = "context";